/**
 *
 *
 */
import React from 'react'
import { Table, Divider, DatePicker, Button, Tooltip, Input, Icon } from 'antd'
import moment from 'moment'
import Page from '../../components/View'
import Cell from '../../components/Cell'
import Crud from '../../components/Crud'
import Api from '../../Api'
import Exception from '../../Exception'
import Adjuntos from './Components/EntregaAdjuntos'
import EntregaForm from './Components/EntregaForm'

export default class EntregasSolicitados extends React.Component {
  /**
   * Constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { width: '50%', title: 'FECHA', dataIndex: 'dFechaEntrega' },
      { width: '43%', title: 'REFERENCIA', dataIndex: 'sReferencia' },
      { width: '7%', title: (<Icon type='block' style={{ fontSize: 20 }} />), dataIndex: 'sFolio', render: (_, record) => (
        <div>
          <Tooltip title='Editar'>
            <Button
              size='small'
              shape='circle-outline'
              icon='edit'
              style={{ marginRight: 7 }}
              onClick={() => this.entregaModal.load(record.iId)}
            />
          </Tooltip>
          <Tooltip title='Adjuntos'>
            <Button
              size='small'
              shape='circle-outline'
              icon='link'
              style={{ marginRight: 7 }}
              onClick={() => this.adjuntos.load(record.iId)}
            />
          </Tooltip>
        </div>
      )}
    ])

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      data: [],
      lookup: [],
    }

    this.entregaModal = null
  }

  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    const fecha = moment()
    this.fetch(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * Cargar
   */
  fetch = async(inicio = -1, termino = -1, search = '') => {
    try {
      this.setState({
        loading: true,
        query: { inicio, termino }
      })

      const filter = search.length > 0 ? { sReferencia: {$like: `%${search}%`} } : {
        $or: [
          {
            dFechaEntrega: { $between: [inicio, termino]}
          }
        ]
      }

      const response = await Api.query({
        model: 'ComProveedorEntrega',
        attributes: [
          'iId',
          'dFechaEntrega',
          'sReferencia',
        ],

        include: [
          {
            as: 'usuarioRegistra',
            attributes: ['iId'],
            where: {
              iIdProveedor: Api.getProviderId(),
              iActivo: true
            }
          },
          // {
          //   as: 'entradas',
          //   attributes: ['iId'],
          //   required: false,
          //   attributes: ['iId'],
          //   where: { iActivo: true },
          // }
        ],

        where: {
          iActivo: true,
          ...filter
        },
        order: [
          ['iId', 'DESC']
        ]
      })

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * Render
   */
  render() {
    const crud = (
      <Crud
        buttons={['add', 'reload']}
        onReload={() =>
          this.fetch(
            this.state.inicio,
            this.state.termino,
            this.state.search
          )
        }
        onAdd={() => this.entregaModal.showModal()}
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (items, fechas) =>
              this.fetch(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.search,
              )
          } />
        <Divider type='vertical' />

        {crud}

        <Divider type='vertical'/>

        <Input.Search
          placeholder='Buscar'
          allowClear
          style={{ width: 185 }}
          onSearch={value =>
            this.fetch(this.state.inicio, this.state.termino, value.trim())
          }
        />
      </div>

    )

    return (
      <Page>
        {/* adjuntos */}
        <Adjuntos
          ref={ref => this.adjuntos = ref}
        />

        {/* form */}
        <EntregaForm
          ref={ref => this.entregaModal = ref}
          onCreate={() => this.fetch(this.state.inicio, this.state.termino, this.state.search)}
        />

        {/* table */}
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1 style={{ margin: 0 }}>Entregas</h1>
          <label>CARGAR DOCUMENTACIÓN REQUERIDA PARA ENTRADAS</label>
          <br />

          <Table
            rowKey='iId'
            size='small'
            rowClassName='row-pure'
            dataSource={this.state.data}
            columns={this.columns}
            loading={this.state.loading}
            pagination={false}
            title={() => tableTitle}
          />
        </div>
      </Page>
    )
  }
}
